import * as React from 'react';
export const IcBloodCells = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7 9c2.21 0 4-1.34 4-3S9.21 3 7 3 3 4.34 3 6s1.79 3 4 3zm11 8c-1.66 0-3 .9-3 2s1.34 2 3 2 3-.9 3-2-1.34-2-3-2zM16.15 6.15c.58-.58.42-1.68-.35-2.45-.77-.77-1.87-.93-2.45-.35-.58.58-.42 1.68.35 2.45.77.77 1.87.93 2.45.35zm-12.2 6.3C2.38 14.02 2.8 17 4.9 19.1c2.1 2.1 5.08 2.52 6.65.95 1.57-1.57 1.15-4.55-.95-6.65-2.1-2.1-5.08-2.52-6.65-.95zM19.3 13.8c1.88-1.88 2.26-4.54.85-5.95-1.41-1.41-4.07-1.03-5.95.85s-2.26 4.54-.85 5.95c1.41 1.41 4.07 1.03 5.95-.85z'
      fill='currentColor'
    />
  </svg>
);
